module.exports = __webpack_public_path__ + "slider-1.ca7e0407c5aedecd1ebc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider-1.jpg
// module id = 455
// module chunks = 2